import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
    }
  },
  gridCopy: { 
    fontSize: 18,
    lineHeight: 1.4,
    textAlign: 'left',
    marginBottom: theme.spacing(4),
  },
  infoNum: {
    color: '#161d1e',
    lineHeight: 1,
    fontWeight: 400,
    fontSize: 36,
    position: 'relative',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      fontSize: 60,
      marginTop: theme.spacing(7)
    }
  },
  infoWrapper: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(7)
    }
  },
  infoText: {
    color: '#666',
    fontSize: 14,
    lineHeight: 1.4,
    [theme.breakpoints.up('md')]: {
      fontSize: 16
    }
  },
  makersTitle: {
    [theme.breakpoints.up('md')]: {
      fontSize: 72,
    },
  },
  mainImage: {
    textAlign: 'center',
    position: 'relative',
    height: 400,
    minWidth: 300,
    [theme.breakpoints.up('sm')]: {
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left'
    }
  },
  circle: {
    position: 'relative',
    top: -225,
    left: 30,
    display: 'inline-block',
    height: 178,
    width: 178,
    borderRadius: '50%',
    [theme.breakpoints.up('md')]: {
      height: 275,
      width: 275,
      top: -275,
      left: 120
    },
    [theme.breakpoints.up('lg')]: {
      height: 325,
      width: 325,
      top: -450,
      left: 200
    }
  },
  stagingGridItem: {
    backgroundColor: theme.palette.common.white,
    height: 80,
    width: 300,
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('md')]: {
      height: 190,
      width: 424
    }
  },
  quoteCarousel: {
    '& .slick-slide': {
      paddingRight: 0,
      opacity: 0,
      transition: 'all .3s',
    },
    '& .slick-current': {
      opacity: 1,
    }
  },
  partnerStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 70,
    paddingBottom: '36px',
    marginBottom: '36px',
    '&:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
    },
    '& a': {
      color: '#080808',
      textDecoration: 'underline !important',
    },
  },
}));
